import { Button } from "@/components/Core/Button";
import ModalSkeleton from "modals/ModalSkeleton";
import classes from "./AreYouSureModal.module.css";

const AreYouSureModal = ({
  show,
  setShow,
  title = "Are You Sure You Want To Delete",
  subTitle = "Once you delete this can’t be recovered",
  onClick,
  isApiCall,
}) => {
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      width={"500px"}
      header={title}
      headerClass={classes.title}
    >
      <div className={classes.content}>
        <p className={[classes.message].join(" ")}>{subTitle}</p>

        <div className={classes.btnsBox}>
          <Button
            onClick={onClick}
            variant={"primary"}
            disabled={isApiCall}
            label={isApiCall ? "Processing" : "Yes"}
          />
          <Button
            onClick={() => setShow(false)}
            disabled={isApiCall}
            variant={"danger"}
            label={"No"}
          />
        </div>
      </div>
    </ModalSkeleton>
  );
};

export default AreYouSureModal;
